import 'setup/initialize-sentry';
import React from 'react';
import { createRoot } from 'react-dom/client';
import SignupRoute from 'routes/signup/SignupRoute';
import { ThemeProvider } from 'utils/theme';
import { PageErrorBoundary } from 'components/error-boundary';
import { HelmetProvider } from 'react-helmet-async';

createRoot(document.getElementById('signup-app')!).render(
  <React.StrictMode>
    <HelmetProvider>
      <ThemeProvider>
        <PageErrorBoundary>
          <SignupRoute />
        </PageErrorBoundary>
      </ThemeProvider>
    </HelmetProvider>
  </React.StrictMode>
);
